var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "32px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7326 0L7.8426 5.05741H16.7978L11.6465 13.0553H15.5479L10.0462 18.7377L7.9871 20.869L4.7359 24.2214L8.21468 16.0826H3.93394L5.23803 13.8067H1.20655C0.541016 13.8087 0.00198373 14.3477 0 15.0133V18.0911C0.00398805 23.3473 4.26614 27.6062 9.52238 27.6062H9.62353C14.8798 27.6062 19.1419 23.3473 19.1459 18.0911V1.20655C19.1439 0.541016 18.6049 0.00198373 17.9394 0H10.7326Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7067 15.1763C27.0733 16.5421 27.841 18.3951 27.841 20.3272C27.8721 22.2656 27.0993 24.1304 25.7061 25.4785C24.3402 26.8453 22.4871 27.6133 20.5548 27.6133C18.6224 27.6133 16.7693 26.8453 15.4034 25.4785C13.3229 23.3943 12.7015 20.2626 13.8286 17.542C14.9558 14.8213 17.6099 13.0466 20.5548 13.0445C22.4869 13.0435 24.3402 13.8104 25.7067 15.1763ZM18.8357 22.9254C20.0669 23.7518 21.7103 23.5942 22.762 22.5488C23.3598 21.9716 23.692 21.1726 23.6795 20.3416C23.6789 18.8588 22.6315 17.5826 21.1773 17.2927C19.7231 17.0027 18.2664 17.7798 17.6972 19.149C17.128 20.5183 17.6045 22.0989 18.8357 22.9254ZM36.5326 18.2609H33.415C32.7215 18.2609 32.3747 18.073 32.3747 17.7009C32.3747 17.3288 32.7359 17.2205 33.415 17.2205H41.5394V13.0445H33.415C29.9471 13.0445 28.2131 14.5918 28.2131 17.6865C28.2123 18.031 28.2364 18.375 28.2854 18.716C28.3849 19.0342 28.4621 19.3589 28.5166 19.6878C29.1524 21.5012 30.7852 22.4079 33.415 22.4079H36.5398C37.2334 22.4079 37.5802 22.5705 37.5802 22.8884C37.5802 23.2641 37.2334 23.4519 36.5398 23.4519H28.2023C27.8353 24.4597 27.2464 25.3721 26.4792 26.1215C25.8746 26.737 25.1651 27.2398 24.384 27.6062H36.547C40.015 27.6062 41.7489 26.0312 41.7489 22.8812C41.7321 19.7913 39.9933 18.2464 36.5326 18.2464V18.2609ZM51.8385 18.2464V13.0445L56 13.0481V25.3304C56 25.934 55.7602 26.5128 55.3334 26.9396C54.9066 27.3664 54.3278 27.6062 53.7242 27.6062H51.8385V22.4079H46.6257V27.6062H42.4642V13.0445H46.6257V18.2464H51.8385Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.810063,
    y1: 17.2421,
    x2: 17.4988,
    y2: 26.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A000EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#BF09BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D20FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E1138A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F01776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5196E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -14.3878,
    y1: 11.4788,
    x2: -11.0784,
    y2: 39.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#26F6E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#20DEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#15B7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0781F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e240c342cc451d3fdb0580edac5041d7.svg";
export { ForwardRef as ReactComponent };